import Maybe from "true-myth/maybe";
import { Money } from "@upserve/financials";

import { Weekday } from "helpers/dates";

export type ISchedules = ISchedule[];

// Notes:
// updatedAt: for both saving and publishing
export interface ISchedule {
  startDate: Maybe<Date>;
  endDate: Maybe<Date>;
  updatedAt: Maybe<Date>;
  people: IPeople;
}

export type IPeople = IPerson[];
export type IUsers = IPosUser[];

export interface IPerson {
  assignee: Maybe<IPosUser>;
  shifts: IShift[];
  unavail: Maybe<IUnavailabilityBlock[]>;
}

export interface IShift {
  role: IRole;
  startTime: Date;
  endTime: Date;
  uuid: string;
}

// Users and Unavailability
export interface IPosUser {
  uuid: string;
  lastName: string;
  firstName: string;
  email: Maybe<string>;
  phone: Maybe<string>;
  roles: IRole[];
}

export type Category =
  | "Front of House"
  | "Back of House"
  | "Other"
  | "Multiple";
export interface IRole {
  uuid: string;
  name: string;
  category: Category;
  payRate: Maybe<Money>;
}

export enum Frequency {
  ONCE = "once",
  WEEKLY = "weekly",
}

export type UnavailType = "UNAVAILABLE" | "EXCEPTION";

export interface IUnavailabilityBlock {
  date: Date;
  dayOfWeek?: Weekday; // only required when Frequency is not "once"
  endTime: Date;
  frequency: Frequency;
  parentId?: string; // only required for exceptions
  startTime: Date;
  type: UnavailType;
  userId: string;
  uuid: string;
}

export type Block = IShift | IUnavailabilityBlock;
